import { typeofArray } from "./typeofUtil";
/*
 * From Ajax, To Redux
 * Function -- 业务 数据三列最优排序 Mic
 */
export function navigationSort(results) {
  var respEmpty = verifyEmpty(results);
  var respSort = lineCount(JSON.parse(JSON.stringify(respEmpty)));
  return respSort.res;
}
/**
 * @function verifyEmpty - organize data
 * @param {Object} request
 * @return {Array} response - [ {content:'洗发产品',list: [{id: 230099, content: "洗发水/液" },{id: 230099, content: "洗发水/液" }] }, {content:'头皮护理',list: [{id: 230099, content: "洗发水/液" }] } ]
 */
function verifyEmpty(request) {
  var response = [];
  if (request.results) {
    request.results.subCategoryList.map((data, index) => {
      if (data.content === "") return;
      response.push({ content: data.content, list: data.childCategoryList });
    });
  }
  return response;
}

/**
 * @function sublineCount - group every single list
 * @param {*} request
 * @return {Array} line - [ [], [], [] ]  || [ [], [] ]
 */
function sublineCount(request) {
  var list = request.list;
  var size = 13;
  var line = [];
  var templine = 0;
  var lineindex = 0;
  for (var i = 0; i < list.length; i++) {
    templine += list[i].content.length + 1;
    if (typeofArray(line[lineindex]) === false) line[lineindex] = [];
    if (templine <= 14) {
      line[lineindex].push(list[i]);
    } else {
      lineindex += 1;
      templine = 0;
      i -= 1;
    }
  }
  return line;
}

/**
 * @function lineCount
 * @param {*} request
 */
// request = [ {content:'洗发产品',list: [{id: 230099, content: "洗发水/液" },{id: 230099, content: "洗发水/液" }] }, {content:'头皮护理',list: [{id: 230099, content: "洗发水/液" }] } ]
function lineCount(request) {
  var tfinishresult = [];
  var tfinishmath = 0;
  var tfinishtotal = [];
  var tm, tno, tn, tf, ts, tt;
  var tfinishmathtemp = 0;

  // to push grouped list to an array    tfinishresult = [ { content:'blabla', list: [ [{id: 230099, content: "洗发水/液" },{id: 230099, content: "洗发水/液" }], [{id: 230099, content: "洗发水/液" }], [{id: 230099, content: "洗发水/液" }] ] } ]
  for (var i = 0; i < request.length; i++) {
    tfinishresult.push({ content: request[i].content, list: sublineCount(request[i]) });
  }
  // tfinishmathtemp -- to record total tfinishresult.list length
  //   debugger;
  for (var i in tfinishresult) {
    if (tfinishresult[i] && tfinishresult[i].list) tfinishmathtemp += tfinishresult[i].list.length;
  }
  // to get middle number
  tfinishmath = tfinishmathtemp / 3;

  // to get all possibilities of combination
  for (tm = 1; tm <= tfinishresult.length; tm++) {
    tno = tfinishresult.length - tm;
    for (tn = 1; tn <= tno; tn++) {
      // if (tm == 0 || tn == 0 || tno - tn == 0) break;
      (tf = 0), (ts = 0), (tt = 0);
      for (var i in tfinishresult.slice(0, tm)) {
        if (tfinishresult.slice(0, tm)[i] && tfinishresult.slice(0, tm)[i].list)
          tf += tfinishresult.slice(0, tm)[i].list.length + 1;
      } // 从 0 开始
      for (var i in tfinishresult.slice(tm, tn + tm)) {
        if (tfinishresult.slice(tm, tn + tm)[i] && tfinishresult.slice(tm, tn + tm)[i].list)
          ts += tfinishresult.slice(tm, tn + tm)[i].list.length + 1;
      } // 从 1 开始
      for (var i in tfinishresult.slice(tm + tn, tm + tno)) {
        if (
          tfinishresult.slice(tm + tn, tm + tno)[i] &&
          tfinishresult.slice(tm + tn, tm + tno)[i].list
        )
          tt += tfinishresult.slice(tm + tn, tm + tno)[i].list.length + 1;
      } // 从 2 开始
      tfinishtotal.push({
        abs: Math.abs(tfinishmath - tf) + Math.abs(tfinishmath - ts) + Math.abs(tfinishmath - tt),
        res: [
          tfinishresult.slice(0, tm),
          tfinishresult.slice(tm, tn + tm),
          tfinishresult.slice(tm + tn, tm + tno),
        ],
      });
    }
  }
  return tfinishtotal.sort((a, b) => a.abs - b.abs)[0];
}



// WEBPACK FOOTER //
// ./common/Utils/navigationHoverSort.js